import React, { ButtonHTMLAttributes } from 'react';

import { Button as StyledButton } from './styles';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>{
  defaultColor?: string;
  hoverColor ?: string;
};

const Button: React.FC<ButtonProps> = ({ children, ...rest }) => {
  return <StyledButton className='defaultButton' {...rest}>{children}</StyledButton>;
};

export default Button;
